import PropConfigList from "../component/PropConfigList";
import React from "react";

const PropConfigListContainer = () => (<PropConfigList />)

export default PropConfigListContainer;